import { useEffect, useMemo, useReducer } from "react";
import { useTranslation } from "react-i18next";

import type { SubmitInfo, UseSubmitInfoStateParams } from "../types";

import { submitInfoReducer } from "../submitInfo.reducer";

export function useSubmitInfoState({ formData, projectId }: UseSubmitInfoStateParams) {
  const { t } = useTranslation();

  const submitInfoDefault = useMemo((): SubmitInfo => {
    const createLabelTag = "AddBuilding.submitModal.rows.projectCreationLabel";
    const updateLabelTag = "AddBuilding.submitModal.rows.projectUpdateLabel";
    const projectActionLabel = projectId ? updateLabelTag : createLabelTag;
    return {
      buildingInfo: {
        name: t("AddBuilding.submitModal.rows.submitBuildingInfo"),
        status: undefined,
      },
      deletedAPIImages: [],
      files: [],
      images: [],
      projectCreation: {
        name: t(projectActionLabel),
        status: undefined,
      },
    };
  }, [projectId, t]);
  const [submitInfo, dispatch] = useReducer(submitInfoReducer, submitInfoDefault);

  useEffect(() => {
    dispatch({ formData, type: "SYNC_FROM_FORM" });
  }, [formData?.files, formData?.images]); // eslint-disable-line react-hooks/exhaustive-deps

  return { dispatch, submitInfo, submitInfoDefault };
}
